import { useState } from "react";
import OTPModal from "../components/OTPModal";
import PlanCard from "../components/PlanCard";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import axiosInstance from "../lib/axiosInstance";
import { FaRegCalendarAlt } from "react-icons/fa";
import moment from "jalali-moment";

const Subscription = () => {
  const { isAuthenticated } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const { data: me } = useQuery({
    queryKey: ["me", "/me"],
    queryFn: () => axiosInstance.get("/me").then((res) => res.data),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: isAuthenticated,
  });
  console.log("me", me);

  const {
    data: plans,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["subscriptions", "/subscription/subscription/"],
    queryFn: () =>
      axiosInstance.get("/subscription/subscription/").then((res) => res.data),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const { name, id, price, price_for_3_months, price_for_12_months } =
    plans || {};

  const handleSelect = async (plan) => {
    if (!isAuthenticated) {
      setSelectedPlan(plan);
      setShowModal(true);
      return;
    }

    try {
      setIsRedirecting(true);
      const duration = plan.duration;
      const endpoint =
        duration === 1
          ? "/subscription/go-to-gateway/"
          : `/subscription/go-to-gateway/${duration}/`;

      const response = await axiosInstance.post(endpoint);
      const { url } = response.data;

      if (url) {
        window.location.href = url;
      } else {
        console.error("url دریافت نشد", response.data);
        setIsRedirecting(false);
      }
    } catch (error) {
      console.error("خطا در هدایت به درگاه پرداخت:", error);
      setIsRedirecting(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-12 text-white relative">
      {me?.subscription_expiry && (
        <div className="bg-[#1E1F2B] border border-gray-700 rounded-2xl px-6 py-5 mb-8 shadow-md text-gray-100 transition-all duration-300">
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gray-800 text-primary">
              <FaRegCalendarAlt size={24} />
            </div>
            <div>
              <p className="text-sm text-gray-400 mb-1">تاریخ پایان اشتراک</p>
              <p className="text-lg font-semibold text-white">
                {moment(me.subscription_expiry)
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </p>
            </div>
          </div>
        </div>
      )}

      <h1 className="text-3xl font-bold mb-6 text-center">{name}</h1>

      {isLoading && (
        <div className="text-center py-8">
          <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
          <p>در حال بارگذاری پلن‌ها...</p>
        </div>
      )}

      {isError && (
        <div className="text-center text-red-400 mt-6">
          خطا در دریافت اطلاعات پلن‌ها. لطفاً مجدد تلاش کنید.
        </div>
      )}

      {!isLoading && !isError && plans && (
        <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {[
            {
              id: `${id}-1month`,
              title: "اشتراک ۱ ماهه",
              description: "پرداخت ماهانه - مناسب استفاده کوتاه‌مدت",
              price,
              duration: 1,
            },
            {
              id: `${id}-3months`,
              title: "اشتراک ۳ ماهه",
              description: "پرداخت سه‌ماهه با تخفیف ویژه",
              price: price_for_3_months,
              duration: 3,
            },
            {
              id: `${id}-12months`,
              title: "اشتراک ۱۲ ماهه",
              description: "پرداخت سالانه با بیشترین صرفه‌جویی",
              price: price_for_12_months,
              duration: 12,
            },
          ].map((plan) => (
            <PlanCard key={plan.id} plan={plan} onSelect={handleSelect} />
          ))}
        </div>
      )}

      <OTPModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccessLogin={() => {
          setShowModal(false);
          refetch();
        }}
      />

      {isRedirecting && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4">
          <div className="bg-[#1E1F2B] text-white rounded-2xl shadow-xl p-7 w-full max-w-sm flex flex-col items-center justify-center text-center">
            <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin mb-4"></div>
            <h2 className="text-lg font-semibold">
              در حال انتقال به درگاه پرداخت...
            </h2>
            <p className="text-sm text-gray-400 mt-2">
              لطفاً منتظر بمانید. تا لحظاتی دیگر به صفحه پرداخت هدایت خواهید شد.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscription;
